import Blue from "~/core";

const OPEN_TOGGLE_SELECTOR = '.js-filterMultiSelectToggle[aria-expanded="true"]';
let documentEventsBound = false;

// One pair of delegated listeners queries the live DOM instead of closing over
// component instances, so Page Builder re-renders never accumulate listeners
// or pin detached markup. Keydown at document level also covers browsers that
// keep focus on <body> after a mouse click on the toggle (Safari).
const bindDocumentEvents = () => {
    if (documentEventsBound) {
        return;
    }
    documentEventsBound = true;

    document.addEventListener("click", (e) => {
        [...document.querySelectorAll(OPEN_TOGGLE_SELECTOR)]
            .filter((toggle) => !toggle.closest(".js-filterMultiSelect").contains(e.target))
            .forEach((toggle) => toggle.setAttribute("aria-expanded", "false"));
    });

    document.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") {
            return;
        }
        [...document.querySelectorAll(OPEN_TOGGLE_SELECTOR)].forEach((toggle) => {
            toggle.setAttribute("aria-expanded", "false");
            const active = document.activeElement;
            if (active === document.body || toggle.closest(".js-filterMultiSelect").contains(active)) {
                toggle.focus();
            }
        });
    });
};

new Blue({
    name: "FilterMultiSelect",
    selector: ".js-filterMultiSelect",
    setup(container) {
        const toggle = container.querySelector(".js-filterMultiSelectToggle");
        const label = container.querySelector(".js-filterMultiSelectLabel");
        const count = container.querySelector(".js-filterMultiSelectCount");
        const panel = container.querySelector(".filter-multiSelect__panel");
        const checkboxes = [...container.querySelectorAll('input[type="checkbox"]')];
        const shortLabel = toggle.getAttribute("data-label");
        const placeholder = toggle.getAttribute("data-placeholder");

        const keepPanelOnScreen = () => {
            panel.style.transform = "";
            const rect = panel.getBoundingClientRect();
            const margin = 16;
            const overflowRight = rect.right - (window.innerWidth - margin);
            const shift = Math.max(0, Math.min(overflowRight, rect.left - margin));
            if (shift > 0) {
                panel.style.transform = `translateX(${-shift}px)`;
            }
        };

        const updateLabel = () => {
            const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length;
            label.textContent = checkedCount > 0 ? shortLabel : placeholder;
            count.textContent = checkedCount > 0 ? checkedCount : "";
            toggle.setAttribute("aria-label", checkedCount > 0 ? `${shortLabel}, ${checkedCount} selected` : placeholder);
        };

        this.$addEvents(toggle, "click.prevent", () => {
            const expanded = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", (!expanded).toString());
            if (!expanded) {
                keepPanelOnScreen();
            }
        });

        this.$addEvents(checkboxes, "change", updateLabel);

        // Browsers restore checkbox state without firing change events on
        // back/forward navigation, so sync the label once on init.
        updateLabel();

        bindDocumentEvents();
    },
});
